import React, { useState } from 'react';
import { View, Text, Image, StyleSheet, Pressable } from 'react-native-web';

const AccountCard = ({ account, currentUserSub, onEnableNotifications }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isChecked, setIsChecked] = useState(account.email_notifications_enabled || false);
  const [isLoading, setIsLoading] = useState(false);

  const isCurrentUser = account.id === currentUserSub;

  const handleCheckboxChange = () => {
    if (isLoading) return;

    setIsLoading(true);
    onEnableNotifications()
      .then(() => {
        setIsChecked(!isChecked);
      })
      .catch((err) => {
        console.error('Error enabling notifications:', err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <View
      style={[styles.container, isHovered && styles.containerHovered]}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Image
        style={styles.profileImage}
        source={{ uri: `https://d3p3fw3rutb1if.cloudfront.net/users-preview/${account.id}` }}
      />
      <View style={{flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', flex: 1, marginLeft: 20, marginRight: 20}}>
        <View style={styles.textContainer}>
            <Text style={styles.nameText}>{account.first_name} {account.last_name}</Text>
            <Text style={styles.emailText}>{account.email}</Text>
        </View>
        {isCurrentUser && (
          <Pressable
            style={styles.checkboxContainer}
            onPress={handleCheckboxChange}
            disabled={isLoading}
          >
            <View style={[styles.checkbox, isChecked && styles.checkboxChecked]}>
              {isChecked && <Text style={styles.checkmark}>✓</Text>}
            </View>
            <Text style={styles.checkboxLabel}>Enable Email Notifications</Text>
          </Pressable>
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: 'white',
    borderRadius: 12,
    padding: 20,
    marginBottom: 16,
    alignItems: 'center',
    borderWidth: 1,
    borderColor: '#e5e7eb',
    flexDirection: 'row',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 3,
    transition: 'all 0.2s ease',
  },
  containerHovered: {
    transform: [{ scale: 1.02 }],
    shadowOpacity: 0.15,
    shadowRadius: 12,
    elevation: 5,
  },
  textContainer: {
    flex: 1,
  },
  profileImage: {
    width: 80,
    height: 80,
    borderRadius: 40,
    borderWidth: 2,
    borderColor: '#f3f4f6',
  },
  nameText: {
    fontSize: 18,
    fontWeight: '900',
    color: '#396de0',
    fontFamily: "'lato', sans-serif",
    marginBottom: 4,
  },
  emailText: {
    fontSize: 16,
    color: '#6b7280',
    fontFamily: "'lato', sans-serif",
  },
  checkboxContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    cursor: 'pointer',
  },
  checkbox: {
    width: 20,
    height: 20,
    borderWidth: 2,
    borderColor: '#396de0',
    borderRadius: 4,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'white',
    transition: 'all 0.2s ease',
  },
  checkboxChecked: {
    backgroundColor: '#396de0',
  },
  checkmark: {
    color: 'white',
    fontSize: 14,
    fontWeight: 'bold',
  },
  checkboxLabel: {
    fontSize: 14,
    color: '#374151',
    fontFamily: "'lato', sans-serif",
    fontWeight: '500',
  },
});

export default AccountCard;